/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useRef, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import "./index.css";

// redux imports
import {
  addItemizedStatementDescription,
  downloadAllItemisizedReport,
  getAllOwnerItemisizedReport,
  ownerAccountsViewAll,
  resetItemisedData,
  setOwnerAllAccItemisedLoading,
  updateItemizedStatementData,
} from "../../../../redux/features/owner/ownerAllVerification/ownerAllVerification";
import {
  addMatchItemisedStatement,
  getAssociatedItemisedStatements,
  removeUnmatchItemisedStatement,
  resetDateRange,
  resetItemisedAllAccStatementData,
  setEndDate,
  setGetItemisedAllAccStatementLoading,
  setStartDate,
} from "../../../../redux/features/accounts/remitterAccount/remitterAccount";

// components imports
import PaginationComponent from "../../../_utils/PaginationComponent";
import { formatAccountNumber } from "../../../_utils/FormatAccountNumber";
import IfscCodeMapper from "../../../_utils/IfscLogoMapper";
import OwnerAccountPopUp from "../OwnerAccountPopUp";
import FormatAmount from "../../../_utils/FormatAmount/FormatAmount";
import Loader from "../../../Loader/Index";
import PrimaryButton from "../../../_utils/CommonButtons/PrimaryButton";
import TEXT from "../../../../utils/globalText";
import PrimaryWithIconButton from "../../../_utils/CommonButtons/PrimaryWithIconButton";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
} from "../../../../utils/configurationProvider";
import SmallPopupWithInput from "../../../_utils/CommonSmallPopupWithInput";
import { linkIdentifier } from "../../../../utils/linkIdentifier";
import CommonToast from "../../../_utils/CommonToast";
import UniversalRefreshToast from "../../../_utils/UniversalRefreshToast";
import ICONS from "../../../../assets/Icons";
import StatementTopNavComponent from "../../../_utils/CommonTopNav/StatementTopNavComponent";
import useCustomSearchParams from "../../../../utils/useCustomSearchParams";
import RemitAccountViewAllPopup from "../../RemitAccount/RemitAccountViewAllPopup";
import LargePopupRedirect from "../../../_utils/CommonPopups/CommonLargePopupRedirect";
import SmallPopup from "../../../_utils/CommonSmallPopup";
import RemitterAccountViewAll from "../../../../containers/Accounts/RemitterAccount/RemitterAccountViewAll";
import SecondaryAnimatedButton from "../../../_utils/CommonButtons/SecondaryAnimated";
import useRestrictedAction from "../../../../hooks/useRestrictedAction";
import { globalTextFormat } from "../../../../utils/globalTextFormat";

const OwnerAccountConsolidatedLiveStatementComp = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const dropdownOptions = PaginationConfiguration.paginationOptions;

  const id = location?.state?.data;
  const type = location?.state?.type;
  const startDateDetails = location?.state?.startDate;
  const endDateDetails = location?.state?.endDate;
  const ownerIddetails = location?.state?.ownerId;
  const matchId = location?.state?.data || "";
  const matchFlowType = location?.state?.flow || "";
  const remitterName = location?.state?.remName || "";
  const remiAcoountId = id || [];

  const scrollRef = useRef(null);
  const timerRef = useRef(null);
  const scrollTopRef = useRef(null);
  const selectAccountRef = useRef(null);

  const { showRestrictedAction, RestrictedActionPopup } = useRestrictedAction();
  const { getAssociatedItemisedData, getAssociatedItemisedLoading } =
    useSelector((state) => state.remitterAccount);
  const {
    ownerAllAccItemisedData,
    ownerAllAccItemisedLoading,
    ownerItemizedAddDescriptionLoading,
  } = useSelector((state) => state.ownerAllVerification);
  const services = useSelector((state) => state.refreshToken.services);

  const { searchParam, handleSearchParams } = useCustomSearchParams({
    pageno: GlobalConfiguration.lengthCheckOne,
    pagesize: dropdownOptions[0],
  });

  const hasMatchPermission = services?.some(
    (service) => service === "AMapping" || service === "Admin",
  );
  const hasUnMatchPermission = services?.some(
    (service) => service === "RMapping" || service === "Admin",
  );

  const hasViewPermission = services?.some(
    (service) => service === "REVAccount" || service === "Admin",
  );

  const convertDate = (dateString) => {
    const date = new Date(dateString);
    const timestamp = Math.floor(
      date.getTime() / IntervalConfiguration.intervalMedium,
    );

    return timestamp;
  };

  const calenderMaxDate = useMemo(() => new Date(), []);

  const defaultStartDate = useMemo(() => {
    return convertDate(new Date(new Date().setDate(1)));
  }, []);

  const defaultEndDate = useMemo(() => {
    return convertDate(new Date());
  }, []);

  const defaultAdditionalDetailCol = [
    { colName: "Bank", colWidth: "column-width-sm", flex: 0 },
    {
      colName: "Transaction date",
      colWidth: "column-width-md",
      flex: 0,
    },
    {
      colName: "Value date",
      colWidth: "column-width-md",
      flex: 0,
    },
    {
      colName: "Party name",
      colWidth: "column-width-lg",
      flex: 1,
    },
    {
      colName: `Amount`,
      colWidth: "column-width-md",
      flex: 0,
    },
    {
      colName: "Narration",
      colWidth: "column-width-lg",
      flex: 1,
    },
    {
      colName: "Bank reference",
      colWidth: "column-width-md",
      flex: 0,
    },
    {
      colName: "Party account number",
      colWidth: "column-width-md",
      flex: 0,
    },
    {
      colName: "Party IFSC",
      colWidth: "column-width-md",
      flex: 0,
    },
    {
      colName: "Description",
      colWidth: "column-width-lg",
      flex: 1,
    },
    ...(props?.flow !== "rejectStatementdetails"
      ? [
          {
            colName: "Remitter account",
            colWidth: "column-width-lg",
            flex: 1,
          },
        ]
      : []),
  ];

  const [additionalDetailColState, setAdditionalDetailsColState] = useState(
    defaultAdditionalDetailCol,
  );
  const [showOwnerPopup, setShowOwnerPopup] = useState(false);
  const [remType, setRemType] = useState("");
  const [matchRemiId, setMatchRemiId] = useState([]);
  const [totalRemiAccount, setTotalRemiAccount] = useState([]);
  const [matchLoader, setMatchLoader] = useState(false);
  const [unmatchLoader, setUnmatchLoader] = useState(false);
  const [selectedCardIds, setSelectedCardIds] = useState([]);
  const [creditAmount, setCreditAmount] = useState("");
  const [showRemiAccounts, setShowRemiAccounts] = useState(false);
  const [selectedLiveStatement, setSelectedLiveStatement] = useState(
    location?.state?.statementid || [],
  );
  const [selectStatementType, setSelectStatementType] = useState(
    location?.state?.flow || "",
  );
  const [openMatchPopup, setOpenMatchPopup] = useState(false);
  const [openDateFilter, setopenDateFilter] = useState(false);
  const [showAmtFilterDiv, setShowAmtFilterDiv] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [isAmtFilterApplied, setIsAmtFilterApplied] = useState(false);
  const [amountRangeFilter, setAmountRangeFilter] = useState({
    min: searchParam.get("min_amount") || "",
    max: searchParam.get("max_amount") || "",
  });
  const [resetTrigger, setResetTrigger] = useState(0);
  const [isDateConfirm, setIsDateConfirm] = useState(false);
  const [flowType, setFlowType] = useState(location?.state?.flow || "");
  const [isFocused, setIsFocused] = useState(false);
  const [statementType, setStatementType] = useState("Credit");
  const [showDescriptionPopup, setShowDescriptionPopup] = useState(false);
  const [description, setDescription] = useState("");
  const [currentDescription, setCurrentDescription] = useState({});
  const [isEditDescription, setIsEditDescription] = useState(false);
  const [matchButton, setMatchButton] = useState(
    (selectStatementType === "remitter_details_match_statement" ||
      selectStatementType === "remitter_edit_match_statement" ||
      flowType === "new_match_txn") &&
      ownerAllAccItemisedData?.ecollection_callbacks >
        GlobalConfiguration.lengthCheckZero
      ? true
      : false,
  );
  const [loadingData, setLoadingData] = useState(false);
  const [active, setActive] = useState("");
  const [selectStatementRow, setSelectStatementRow] = useState([]);
  const [unmatchStatement, setUnMatchStatement] = useState("");
  const [matchStatement, setMatchStatement] = useState("");
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [unmatchRemiId, setUnmatchRemiId] = useState([]);
  const [alertPopup, setAlertPopup] = useState(false);
  const [pendingNavTarget, setPendingNavTarget] = useState(null);
  const [pageSize, setPageSize] = useState(dropdownOptions[0]);
  const [selectedValue, setSelectedValue] = useState(dropdownOptions[0]);
  const [selectedtBankState, setSelectedtBankState] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const amountLimitState = {
    min: "",
    max: "",
  };
  const [accountnumberstate, setaccountnumberstate] = useState(
    ownerIddetails
      ? [ownerIddetails]
      : props?.flow === "rejectStatementdetails"
        ? []
        : props?.popType === "ownerStatement" ||
            props?.popType === "remitterBankStatement"
          ? props?.ownerDetailId
            ? [props?.ownerDetailId]
            : []
          : [],
  );
  const [accountNumber, setAccountNumber] = useState(
    ownerIddetails
      ? location?.state?.type === "consolidatedFullView"
        ? [ownerIddetails]
        : ownerIddetails
      : props?.popType == "ownerStatement" || props?.popType
        ? [props?.ownerDetailId]
        : [],
  );
  const [accountDefaultNumber, setDefaultAccountNumber] = useState(
    ownerIddetails
      ? [ownerIddetails]
      : props?.popType == "ownerStatement" || props?.popType
        ? [props?.ownerDetailId]
        : [],
  );
  const [selectedType, setSelectedType] = useState("XLSX");
  const [startDateState, setStartDateState] = useState(
    startDateDetails ||
      (props?.flow === "rejectStatementdetails" ? "" : defaultStartDate),
  );
  const [endDateState, setEndDateState] = useState(
    endDateDetails ||
      (props?.flow === "rejectStatementdetails" ? "" : defaultEndDate),
  );
  const matchCondition =
    matchFlowType === "new_match_txn" ||
    matchFlowType === "remitter_details_match_statement" ||
    matchFlowType === "remitter_edit_match_statement";

  const columnMapper = {
    owner_bank_account_number: "owner_bank_account_number",
    IFSC_Code: "ifsc_code",
    Bank: "bank_name",
    Name: "name",
    Party_name: "party_name",
    Party_IFSC: "party_ifsc",
    Party_account_number: "party_account_number",
    Transaction_date: "transaction_date",
    Value_date: "value_date",
    Narration: "narration",
    Amount: "amount",
    Bank_reference: "bank_reference",
    Type: "credit_debit",
    Description: "description",
  };

  const callbacks =
    type === TEXT?.REMITTER_DETAILS ||
    props?.flow === TEXT?.REMITTER_DETAILS ||
    props?.flow === "rejectStatementdetails"
      ? getAssociatedItemisedData?.ecollection_callbacks
      : ownerAllAccItemisedData?.ecollection_callbacks;

  const visibleRowIds =
    callbacks?.map(
      (item, index) =>
        item?.ecollection_callback_id || item?.id || `${currentPage}-${index}`,
    ) || [];

  const currentPageSelectableIds = visibleRowIds.filter(
    (id) => !selectedLiveStatement?.includes(id),
  );

  const currentPageSelectedIds = currentPageSelectableIds.filter((id) =>
    selectStatementRow.includes(id),
  );

  const currentPageSelectedCount = currentPageSelectedIds.length;

  const totalUserSelectedCount = selectStatementRow.filter(
    (id) => !selectedLiveStatement?.includes(id),
  ).length;

  const remainingSelection = Math.max(
    Number(pageSize) - totalUserSelectedCount,
    GlobalConfiguration?.lengthCheckZero,
  );

  const hasSelectionOutsideCurrentPage =
    currentPageSelectedCount === GlobalConfiguration.lengthCheckZero &&
    selectStatementRow.some(
      (id) =>
        !selectedLiveStatement?.includes(id) &&
        !currentPageSelectableIds.includes(id),
    );

  const shouldClearPreviousSelection =
    hasSelectionOutsideCurrentPage &&
    remainingSelection === GlobalConfiguration.lengthCheckZero;

  const totalSelectedCount = totalUserSelectedCount;

  const totalVisibleSelectableCount = currentPageSelectableIds.length;

  const isAllVisibleSelected =
    totalVisibleSelectableCount > 0 &&
    currentPageSelectedCount === totalVisibleSelectableCount;

  const computeVariant = (value, focused) => {
    const length = (value ?? "").trim().length;

    if (length === GlobalConfiguration?.lengthCheckZero) return "default";

    if (length >= GlobalConfiguration?.lengthCheckZero) {
      return "verified";
    }

    return focused ? TEXT?.TYPING : TEXT?.ERROR;
  };

  const isDateCustom = useMemo(() => {
    if (props?.flow === "rejectStatementdetails") {
      return Boolean(startDateState || endDateState);
    }
    return (
      isDateConfirm &&
      (Number(startDateState) !== Number(defaultStartDate) ||
        Number(endDateState) !== Number(defaultEndDate))
    );
  }, [
    startDateState,
    endDateState,
    defaultStartDate,
    defaultEndDate,
    isDateConfirm,
    props?.flow,
  ]);

  const condition =
    isDateCustom ||
    selectedtBankState.length > GlobalConfiguration.lengthCheckZero ||
    (matchStatement !== "" && unmatchStatement !== "") ||
    matchStatement !== "" ||
    unmatchStatement !== "" ||
    creditAmount !== "" ||
    (amountRangeFilter.min.length > GlobalConfiguration.lengthCheckZero &&
      amountRangeFilter.max.length > GlobalConfiguration.lengthCheckZero);

  const handleClearParameters = () => {
    move();

    if (props?.flow === "rejectStatementdetails") {
      setaccountnumberstate([]);
      setAccountNumber([props?.ownerDetailId]);
      setStartDateState("");
      setEndDateState("");
    } else {
      setaccountnumberstate(accountDefaultNumber);
      setAccountNumber(accountDefaultNumber);
      setStartDateState(defaultStartDate);
      setEndDateState(defaultEndDate);
    }

    setCreditAmount("");
    setSelectedtBankState("");
    setAmountRangeFilter({ min: "", max: "" });
    setUnMatchStatement("");
    setMatchStatement("");
    setMatchButton(false);
    setIsAmtFilterApplied(false);
    setIsDateConfirm(false);
    setCurrentPage(1);
  };

  const isToday = (date) => {
    const d = new Date(date * 1000);
    const today = new Date();
    return (
      d.getFullYear() === today.getFullYear() &&
      d.getMonth() === today.getMonth() &&
      d.getDate() === today.getDate()
    );
  };

  const clearPolling = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
  };

  const startPolling = () => {
    clearPolling();

    if (!isToday(endDateState) || matchButton) return;

    timerRef.current = setTimeout(
      async () => {
        await fetchData();
      },
      5 * 60 * 1000,
    );
  };

  const fetchData = async () => {
    setResetTrigger((prev) => prev + GlobalConfiguration?.lengthCheckOne);
    if (
      type === TEXT?.REMITTER_DETAILS ||
      props?.flow === TEXT?.REMITTER_DETAILS ||
      props?.flow === "rejectStatementdetails"
    ) {
      dispatch(
        getAssociatedItemisedStatements({
          page_no: currentPage,
          page_size: pageSize,
          remitter_account_id: props?.remitter_account_id,
          ecollection_callback_id: props?.statement_entry_id
            ? props?.statement_entry_id
            : [],
          min_amount: isAmtFilterApplied ? amountRangeFilter.min : "",
          max_amount: isAmtFilterApplied ? amountRangeFilter.max : "",
          start_date: startDateState,
          end_date: endDateState,
        }),
      );
    } else {
      await dispatch(
        getAllOwnerItemisizedReport({
          id: accountNumber?.map((itm) => (itm?.id ? itm?.id : itm)),
          start_date: startDateState,
          end_date: endDateState,
          page_no: currentPage,
          sort_by:
            matchStatement === TEXT?.MATCHED
              ? "mapped"
              : unmatchStatement === TEXT?.UNMATCHED
                ? "unmapped"
                : "",
          credit_debit: statementType?.toLowerCase(),
          start_amount: isAmtFilterApplied ? amountRangeFilter.min : "",
          end_amount: isAmtFilterApplied ? amountRangeFilter.max : "",
          credit_amount: creditAmount || "",
          page_size: pageSize,
          bank_name: undefined,
        }),
      ).unwrap();
    }
    startPolling();
  };

  const handleSubmit = (key, value) => {
    handleSearchParams(key, value);
  };

  const handleMatchStatement = async (matchid) => {
    setMatchLoader(true);
    UniversalRefreshToast(
      flowType === "new_match_txn" ||
        flowType === "remitter_details_match_statement" ||
        selectStatementType === "remitter_edit_match_statement"
        ? "Matching transactions to the selected accounts."
        : "Matching remitter.",
    );
    try {
      const data = await dispatch(
        addMatchItemisedStatement({
          remitter_accounts_ids: Array.isArray(matchid) ? matchid : [matchid],
          mapping_ids: Array.isArray(selectStatementRow)
            ? selectStatementRow
            : [selectStatementRow],
        }),
      );

      if (data?.payload?.status === true) {
        toast.dismiss();
        CommonToast({
          text:
            flowType === "new_match_txn" ||
            flowType === "remitter_details_match_statement" ||
            selectStatementType === "remitter_edit_match_statement"
              ? `${
                  selectStatementRow?.length ===
                  GlobalConfiguration.lengthCheckOne
                    ? TEXT?.TRANSACTION
                    : `${TEXT?.TRANSACTION}s`
                } matched to the selected ${matchCondition ? TEXT?.ACCOUNT : TEXT?.ACCOUNTS?.toLowerCase()} successfully.`
              : TEXT?.REMITTER_MATCH_SUCCESS,
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          buttonNeeded: false,
        });
        if (remiAcoountId?.length > GlobalConfiguration.lengthCheckZero) {
          navigate(
            `/remitter_account_dashboard/remitter_account_view_all/remitter_account_detail_page/${remiAcoountId}`,
            {
              state: {
                flow: "live_match_transaction",
              },
            },
          );
        } else {
          setOpenMatchPopup(false);
          setShowRemiAccounts(false);
          setSelectedCardIds([]);
          fetchData();
          setMatchButton(false);
          setSelectStatementRow([]);
        }
      } else {
        CommonToast({
          text:
            data?.payload?.message ||
            data?.payload?.errors?.base?.[0] ||
            "Failed to match transactions.",
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }
    } catch (error) {
      CommonToast({
        text: TEXT?.SOMETHING_WENT_WRONG,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    }
    setOpenMatchPopup(false);
    setMatchLoader(false);
    setRemType("");
  };

  const handleUnMatchStatement = async (matchid) => {
    setUnmatchLoader(true);
    UniversalRefreshToast(TEXT?.UNMATCHING_REMITTER);

    try {
      let data = await dispatch(
        removeUnmatchItemisedStatement({
          remitter_accounts_ids: matchid,
          mapping_ids: Array.isArray(selectStatementRow)
            ? selectStatementRow
            : [selectStatementRow],
        }),
      );

      if (data?.payload?.status === true) {
        toast.dismiss();
        CommonToast({
          text: TEXT?.REMITTER_UNMATCH_SUCCESS,
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          buttonNeeded: false,
        });

        setShowRemiAccounts(false);
        setSelectStatementRow([]);
        setUnmatchRemiId([]);
        fetchData();
        setSelectedCardIds([]);
      } else {
        CommonToast({
          text:
            data?.payload?.message ||
            data?.payload?.errors?.base?.[0] ||
            TEXT?.FAILED_UNMATCH_TRANSACTION,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
        setSelectStatementRow([]);
        setUnmatchRemiId([]);
        setUnmatchLoader(false);
      }
    } catch (error) {
      CommonToast({
        text: "Something went wrong.",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    }
    setOpenMatchPopup(false);
    setUnmatchLoader(false);
    setRemType("");
  };

  const handleAlertCancel = () => {
    setAlertPopup(false);
    setPendingNavTarget(null);
  };

  const handleLeaveConfirm = () => {
    setAlertPopup(false);
    setShowRemiAccounts(false);
    if (pendingNavTarget) {
      navigate(pendingNavTarget);
    }
    setPendingNavTarget(null);
  };

  const downloadStatement = async () => {
    UniversalRefreshToast(TEXT?.DOWNLOADING_STATEMENT);
    setIsDisabled(true);
    try {
      const response = await dispatch(
        downloadAllItemisizedReport({
          id: accountNumber,
          start_date: startDateState,
          end_date: endDateState,
          credit_debit: statementType?.toLowerCase(),
          start_amount: isAmtFilterApplied ? amountRangeFilter.min : "",
          end_amount: isAmtFilterApplied ? amountRangeFilter.max : "",
          page_size: pageSize,
          formatType: selectedType.toLowerCase(),
          bank_name: undefined,
          filter_columns: additionalDetailColState?.map(
            (itm) => columnMapper[itm.colName.replaceAll(" ", "_")],
          ),
        }),
      );
      toast.dismiss();
      CommonToast({
        text: TEXT?.DOWNLOAD_STATEMENT_SUCCESS,
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      setIsDisabled(false);
    } catch (error) {
      toast.dismiss();
      CommonToast({
        text: TEXT?.DOWNLOAD_STATEMENT_FAILED,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      setIsDisabled(false);
      console.error(error);
    }
  };

  const handleSelect = (value) => {
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
    setSelectedValue(value);
    setPageSize(value);

    if (Number(value) < Number(pageSize)) {
      const callbacks =
        type === TEXT?.REMITTER_DETAILS ||
        props?.flow === TEXT?.REMITTER_DETAILS ||
        props?.flow === "rejectStatementdetails"
          ? getAssociatedItemisedData?.ecollection_callbacks
          : ownerAllAccItemisedData?.ecollection_callbacks;

      const visibleIds =
        callbacks
          ?.slice(0, Number(value))
          ?.map(
            (item, index) =>
              item?.ecollection_callback_id || item?.id || `1-${index}`,
          ) || [];

      setSelectStatementRow((prev) =>
        prev.filter(
          (id) =>
            selectedLiveStatement?.includes(id) || visibleIds.includes(id),
        ),
      );
    }
  };

  const handlePagination = (page) => {
    if (scrollRef?.current) {
      scrollRef.current.scrollLeft = GlobalConfiguration.lengthCheckZero;
    }
    setCurrentPage(page);
  };

  const move = () => {
    scrollRef?.current?.scrollTo({ left: 0, behavior: "smooth" });
    setTimeout(() => {
      scrollTopRef?.current?.scrollTo({ top: 0, behavior: "smooth" });
    }, 500);
  };

  const handleDateChange = (date) => {
    if (Array.isArray(date) && date[0] && date[1]) {
      const [start, end] = date;
      const startTs = convertDate(start);
      const endTs = convertDate(end);

      setStartDateState(startTs);
      setEndDateState(endTs);
      setIsDateConfirm(
        Number(startTs) !== Number(defaultStartDate) ||
          Number(endTs) !== Number(defaultEndDate),
      );

      if (props?.flow === "remitterBankStatement") {
        dispatch(setStartDate(startTs));
        dispatch(setEndDate(endTs));
      }
      handleSearchParams("date", `${startTs},${endTs}`);
    } else {
      setStartDateState(defaultStartDate);
      setEndDateState(defaultEndDate);

      handleSearchParams("date", "");
    }
  };

  const handleAddDetail = (name) => {
    if (!additionalDetailColState.some((x) => x.colName === name)) {
      let data = {
        colName: name,
        colWidth: defaultAdditionalDetailCol.find((x) => x.colName === name)
          .colWidth,
        flex: defaultAdditionalDetailCol.find((x) => x.colName === name).flex,
      };
      let arr = [...additionalDetailColState, data].sort(
        (a, b) =>
          defaultAdditionalDetailCol.map((x) => x.colName).indexOf(a.colName) -
          defaultAdditionalDetailCol.map((x) => x.colName).indexOf(b.colName),
      );
      setAdditionalDetailsColState(arr);
    } else {
      if (
        additionalDetailColState?.length === GlobalConfiguration?.lengthCheckOne
      ) {
        return CommonToast({
          text: TEXT?.COLUMN_REQUIREMENT,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }

      setAdditionalDetailsColState(
        additionalDetailColState
          .filter((itm) => {
            return name !== itm.colName;
          })
          .sort(
            (a, b) =>
              defaultAdditionalDetailCol
                .map((x) => x.colName)
                .indexOf(a.colName) -
              defaultAdditionalDetailCol
                .map((x) => x.colName)
                .indexOf(b.colName),
          ),
      );
    }
  };

  const handleCardNavigate = (targetPath) => {
    setPendingNavTarget(targetPath);
    setAlertPopup(true);
  };

  const formatDateandTime = (
    input,
    showtime = false,
    hour = false,
    showminutes = false,
    showmeridian = false,
    readable = false,
  ) => {
    let date;

    if (input instanceof Date) {
      date = input;
    } else if (typeof input === "number" || /^\d+$/.test(input)) {
      const ts = Number(input);
      date = new Date(ts < 1e12 ? ts * 1000 : ts);
    } else if (typeof input === "string") {
      date = new Date(input);
    } else {
      return "-";
    }

    if (isNaN(date.getTime())) return "-";

    const day = date.getDate();
    const month = date.getMonth();
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = date.getMinutes();

    const ampm = hours >= 12 ? "pm" : "am";
    const displayHour = hours % 12 || 12;

    const pad = (n) => (n < 10 ? `0${n}` : n);

    // ---------- DATE PART ----------
    const datePart = readable
      ? `${day} ${date.toLocaleString("default", { month: "short" })} ${year}`
      : `${day}-${month + GlobalConfiguration?.lengthCheckOne}-${year}`;

    if (!showtime) return datePart;

    // ---------- TIME PART ----------
    let timeParts = [];

    if (hour) timeParts.push(pad(displayHour));
    if (showminutes) timeParts.push(pad(minutes));

    let timePart = timeParts.join(":");

    if (showmeridian && timePart) {
      timePart += ` ${ampm}`;
    }

    return timePart ? `${datePart}, ${timePart}` : datePart;
  };

  const handleSearch = (text) => {
    setSearchUserTextDebounce(text);
  };

  const handleAmtFilterApply = () => {
    if (Object.values(amountLimitState).includes("")) return;
    setIsAmtFilterApplied(true);
    setTimeout(() => {
      setShowAmtFilterDiv(false);
    }, 500);
  };

  const handleKey = (event) => {
    if (showAmtFilterDiv) {
      if (event.key === "Enter" && showAmtFilterDiv && isAmtFilterApplied) {
        handleAmtFilterApply();
      }
    }
  };

  const actionRestricted = () => {
    showRestrictedAction({
      path: `/owner_account_dashboard/consolidated_live_statement/`,
      state: {
        startDate: startDateState,
        endDate: endDateState,
        ownerId: accountNumber,
      },
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        await dispatch(ownerAccountsViewAll({}));
      } catch (error) {
        console.error("Failed to fetch owner accounts:", error);
      }
    };

    fetchData();

    return () => {
      dispatch(resetItemisedData());
    };
  }, []);

  useEffect(() => {
    if (!accountNumber.length) {
      if (
        type === TEXT?.REMITTER_DETAILS ||
        props?.flow === TEXT?.REMITTER_DETAILS ||
        props?.flow === "rejectStatementdetails"
      ) {
        dispatch(setGetItemisedAllAccStatementLoading(false));
      } else {
        dispatch(setOwnerAllAccItemisedLoading(false));
      }
      clearPolling();
      return;
    }

    fetchData();

    return () => {
      dispatch(resetItemisedAllAccStatementData());

      clearPolling();
    };
  }, [
    accountNumber,
    currentPage,
    pageSize,
    amountRangeFilter,
    creditAmount,
    startDateState,
    endDateState,
    type,
    matchStatement,
    statementType,
    unmatchStatement,
  ]);

  useEffect(() => {
    return () => {
      if (props?.flow !== "ownerDetail") {
        dispatch(resetDateRange());
      }
    };
  }, []);

  useEffect(() => {
    const fetchItemisedStatements = async () => {
      if (
        type === TEXT?.REMITTER_DETAILS ||
        props?.flow === TEXT?.REMITTER_DETAILS ||
        props?.flow === "rejectStatementdetails"
      ) {
        const response = await dispatch(
          getAssociatedItemisedStatements({
            remitter_account_id: remiAcoountId,
            page_no: currentPage,
            page_size: pageSize,
          }),
        );

        if (getAssociatedItemisedStatements.fulfilled.match(response)) {
          const callbacks = response?.payload?.ecollection_callbacks || [];

          const statementIds = callbacks
            .map((data) => data?.ecollection_callback_id)
            .filter(Boolean);

          setSelectedLiveStatement(statementIds);
        }
      }
    };

    if (matchCondition) {
      fetchItemisedStatements();
    }
  }, [currentPage, pageSize, remiAcoountId]);

  useEffect(() => {
    if (condition) {
      move();
    }
  }, [condition, matchStatement]);

  useEffect(() => {
    if (
      (selectStatementType === "remitter_details_match_statement" ||
        selectStatementType === "remitter_edit_match_statement" ||
        flowType === "new_match_txn") &&
      ownerAllAccItemisedData?.ecollection_callbacks?.length >
        GlobalConfiguration.lengthCheckZero
    ) {
      setMatchButton(true);
    }
  }, [
    selectStatementType,
    flowType,
    ownerAllAccItemisedData?.ecollection_callbacks?.length,
  ]);

  useEffect(() => {
    scrollRef.current?.scrollTo({
      left: 0,
      behavior: "smooth",
    });
  }, [condition]);

  useEffect(() => {
    document.addEventListener("keydown", handleKey);
    return () => {
      document.removeEventListener("keydown", handleKey);
    };
  }, [isAmtFilterApplied, showAmtFilterDiv]);

  return (
    <>
      {<>{RestrictedActionPopup}</>}
      {alertPopup && (
        <div
          className="fixed z-z-index-max flex items-center justify-center top-left-base left-left-base w-width-full h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity"
          onClick={(e) => e.stopPropagation()}
        >
          <SmallPopup
            headerTitle={TEXT?.LEAVE_PAGE_WARNING_HEADER}
            headerFontWeight="semibold"
            headerFontColor="emphasis"
            textSize="font-lg"
            subtext={TEXT?.LEAVING_PAGE_WILL_EXIT_FROM_CURRENT_FLOW}
            btnOneText={TEXT?.STAY}
            btnOneHandleFunction={handleAlertCancel}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption={TEXT?.WHITE}
            btnTwoText={TEXT?.LEAVE}
            btnTwoHandleFunction={handleLeaveConfirm}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={false}
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoIsLoaderNeeded={true}
            btnTwoHoverOption={TEXT?.BLACK}
          />
        </div>
      )}
      {showRemiAccounts && (
        <>
          <div
            className="fixed z-z-index-modal flex items-center justify-center top-left-base left-left-base w-width-full h-height-full bg-opacity-dark-opacity"
            onClick={(e) => e.stopPropagation()}
          >
            <LargePopupRedirect
              headerTitle={
                remType === "remitterUnmatch"
                  ? TEXT?.UNMATCH_REMITTER_ACCOUNTS
                  : remType === "remitterMatch"
                    ? TEXT?.MATCH_REMITTER_ACCOUNTS
                    : TEXT?.REMITTER_ACCOUNTS
              }
              headersubtext={
                remType === "remitterUnmatch"
                  ? TEXT?.ONLY_MATCHED_ACCOUNTS_SELECTION_NOTE
                  : remType === "remitterMatch"
                    ? TEXT?.ONLY_UNMATCHED_ACCOUNT_SELECTION_NOTE
                    : TEXT?.ALL_ACCOUNTS_MATCHED
              }
              closeiconenabledBgColor="var(--primary-nav)"
              closeiconisLoading={false}
              closeiconhandleFunction={() => {
                if (!matchButton) {
                  setMatchRemiId("");
                  setSelectedCardIds([]);
                  setSelectStatementRow([]);
                }
                setTotalRemiAccount("");
                setUnmatchRemiId("");
                setRemType("");
                setShowRemiAccounts(false);
              }}
              closeicon={ICONS?.CLOSE}
              closeiconhoverOption={TEXT?.WHITE}
              closeiconbtnType={TEXT?.BUTTON}
              closeiconisDisabled={false}
              closeicondisabledBgColor={""}
              smallpopupsubtext={TEXT?.LEAVING_PAGE_WILL_EXIT_FROM_CURRENT_FLOW}
              closeiconbuttonRef={null}
              closeicontitle={TEXT?.CLOSE}
              btnType={
                remType === "remitterUnmatch"
                  ? TEXT?.UNMATCH
                  : remType === "remitterMatch"
                    ? TEXT?.MATCH
                    : TEXT?.CONFIRM
              }
              handleFunction={() => {
                if (remType === "remitterUnmatch") {
                  if (
                    selectedCardIds?.length >
                    GlobalConfiguration.lengthCheckZero
                  ) {
                    if (
                      services?.find(
                        (service) =>
                          service === "RMapping" || service === "Admin",
                      ) !== undefined
                    ) {
                      handleUnMatchStatement(selectedCardIds);
                    } else {
                      navigate("/feature_not_assigned", {
                        state: {
                          unavailableService: "RMapping",
                        },
                      });
                    }
                  }
                } else {
                  if (
                    selectedCardIds?.length >
                    GlobalConfiguration.lengthCheckZero
                  ) {
                    if (
                      services?.find(
                        (service) =>
                          service === "AMapping" || service === "Admin",
                      ) !== undefined
                    ) {
                      handleMatchStatement(selectedCardIds);
                    } else {
                      navigate("/feature_not_assigned", {
                        state: {
                          unavailableService: "AMapping",
                        },
                      });
                    }
                  }
                }
              }}
              enabledBgColor={
                selectedCardIds?.length > GlobalConfiguration.lengthCheckZero
                  ? "var(--positive-act)"
                  : "var(--text-disabled)"
              }
              hoverOption={TEXT?.DARK}
              outLineColor={""}
              enabledTextColor={"var(--text-primary)"}
              isDisabled={
                !selectedCardIds?.length > GlobalConfiguration.lengthCheckZero
              }
              disabledTextColor={""}
              isLoading={unmatchLoader || matchLoader ? true : false}
              disabledBgColor={""}
              fullWidthRequired={true}
              isbottomSectionneed={
                remType === "remitterUnmatch" || remType === "remitterMatch"
              }
              bottomHeaderTextNeed={true}
              confirmbtnrequired={
                remType === "remitterUnmatch" || remType === "remitterMatch"
              }
              inActiveVariantNeeded
              bottomHeaderText={
                remType === "remitterUnmatch"
                  ? TEXT?.UNMATCH_SELECTED_TRANSACTION
                  : remType === "remitterMatch"
                    ? TEXT?.CLICK_MATCH_TRANSACTION
                    : TEXT?.CONFIRM_MATCH_TRANSACTION
              }
              btnText={
                remType === "remitterUnmatch"
                  ? TEXT?.UNMATCH
                  : remType === "remitterMatch"
                    ? TEXT?.MATCH
                    : TEXT?.CONFIRM
              }
              isfullViewrequired={remType === "remitterMatch" && true}
              fullviewbtnText={TEXT?.REGISTER_NEW_ACCOUNT}
              redirectHeader={TEXT?.REGISTER_NEW_ACCOUNT}
              fullviewhandleFunction={() => {
                navigate("/remitter_account_dashboard/create_remitter_account");
              }}
              smallPopupHeader={TEXT?.LEAVE_PAGE_WARNING_HEADER}
              redirectIcon={ICONS?.ADD_BUTTON_WHITE}
            >
              <RemitterAccountViewAll
                remid={
                  totalRemiAccount?.length > GlobalConfiguration.lengthCheckZero
                    ? totalRemiAccount?.[0]
                    : unmatchRemiId?.length >
                        GlobalConfiguration.lengthCheckZero
                      ? unmatchRemiId
                      : matchRemiId?.length >
                          GlobalConfiguration.lengthCheckZero
                        ? matchRemiId
                        : ""
                }
                type={"RemitterAcc"}
                remType={remType}
                remiAcoountId={remiAcoountId}
                onCardNavigate={
                  remType !== "remitterUnmatch" &&
                  remType !== "remitterMatch" &&
                  handleCardNavigate
                }
                handleConfirmBtnClick={(e) => {}}
                selectedCardIds={selectedCardIds}
                setSelectedCardIds={setSelectedCardIds}
                cardType={
                  remType === "remitterUnmatch" || remType === "remitterMatch"
                    ? "matchRemAcc"
                    : ""
                }
                createDisabled={false}
                showModalPopup={true}
              />
            </LargePopupRedirect>
          </div>
        </>
      )}

      {showDescriptionPopup && (
        <div
          style={{ zIndex: "var(--z-index-modal)" }}
          className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center bg-opacity-dark-opacity"
        >
          <SmallPopupWithInput
            headerTitle={TEXT?.DESCRIPTION}
            headerFontColor="text-primary"
            headerFontWeight="semibold"
            textSize="font-md"
            subtext={TEXT?.PROVIDE_CUSTOM_DESCRIPTION}
            inputIsFullWidth={true}
            inputBgColor="var(--primary-bg)"
            inputPlaceholder={TEXT?.DESCRIPTION}
            bulletPoints={[TEXT?.TRACKING_AND_RECONCILIATION_NOTE]}
            inputFgColor={
              description?.length
                ? "var(--text-primary)"
                : "var(--text-secondary)"
            }
            inputVariant={computeVariant(description, isFocused)}
            inputOnFocus={(e) => setIsFocused(true)}
            inputOnBlur={(e) => setIsFocused(false)}
            inputValue={description}
            inputFontKind="medium"
            inputOnInput={(e) => {
              if (
                e.target.value?.replace(/\s+/g, " ").trimStart()?.length <=
                GlobalConfiguration.inputMaxLength
              )
                setDescription(
                  e.target.value?.replace(/\s+/g, " ").trimStart(),
                );
            }}
            btnOneText={TEXT?.CANCEL}
            btnOneBtnType={TEXT?.BUTTON}
            btnOneHandleFunction={() => {
              if (!ownerItemizedAddDescriptionLoading) {
                setShowDescriptionPopup(false);
                setDescription("");
                setCurrentDescription({});
              }
            }}
            btnOneEnabledBgColor="transparent"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={ownerItemizedAddDescriptionLoading}
            btnOneHoverOption={TEXT?.WHITE}
            btnTwoText={
              currentDescription?.description?.length
                ? TEXT?.CONFIRM
                : TEXT?.ADD
            }
            btnTwoBtnType={TEXT?.BUTTON}
            btnTwoHandleFunction={async () => {
              if (!ownerItemizedAddDescriptionLoading) {
                let response = await dispatch(
                  addItemizedStatementDescription({
                    id: currentDescription.acc_id,
                    statement_entry_id:
                      currentDescription.ecollection_callback_id,
                    description: description,
                  }),
                );
                if (response?.payload?.status)
                  dispatch(
                    updateItemizedStatementData({
                      description: description,
                      ecollection_callback_id:
                        currentDescription.ecollection_callback_id,
                    }),
                  );
                setCurrentDescription({});
                setIsEditDescription(false);
                setShowDescriptionPopup(false);
                setDescription("");
              }
            }}
            btnTwoEnabledBgColor="var(--positive-act)"
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoDisabledTextColor="var(--text-primary)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={
              (!isEditDescription && !description?.length) ||
              description === currentDescription?.description
            }
            btnTwoIsLoading={ownerItemizedAddDescriptionLoading}
            btnTwoIsLoaderNeeded={true}
            btnTwoHoverOption={TEXT?.BLACK}
            btnTwoInActiveVariantNeeded={true}
          />
        </div>
      )}

      {openMatchPopup && (
        <>
          <div style={{ zIndex: "var(--z-index-modal)" }}>
            <RemitAccountViewAllPopup
              id={remiAcoountId}
              type={"RemitterAcc"}
              headerTitle={TEXT?.MATCH_REMITTER_ACCOUNTS}
              headersubtext={TEXT?.ONLY_ACTIVE_ACCOUNTS_SELECTABLE}
              closePopup={() => setOpenMatchPopup(false)}
              handleConfirmBtnClick={(e) => {
                handleMatchStatement(e);
              }}
              btnText={TEXT?.MATCH}
              cardType={"matchRemAcc"}
              bottomHeaderText={TEXT?.CLICK_MATCH_TRANSACTION}
              isfullViewrequired={true}
              fullviewbtnText={TEXT?.REGISTER_NEW_ACCOUNT}
              redirectHeader={TEXT?.REGISTER_NEW_ACCOUNT}
              fullviewhandleFunction={() => {
                navigate("/remitter_account_dashboard/create_remitter_account");
              }}
              redirectIcon={ICONS?.ADD_BUTTON_WHITE}
              createDisabled={false}
              smallPopupHeader={TEXT?.LEAVE_PAGE_WARNING_HEADER}
              showModalPopup={true}
            />
          </div>
        </>
      )}

      {showOwnerPopup && (
        <div
          style={{ zIndex: "var(--z-index-modal)" }}
          className="fixed top-top-base left-left-base w-width-full h-height-full bg-Primary-black bg-opacity-light-opacity"
        >
          <OwnerAccountPopUp
            setOpenOwner={() => {
              setShowOwnerPopup(false);
            }}
            onClosed={() => setShowOwnerPopup(false)}
            accountNumber={accountNumber}
            setAccountNumber={setAccountNumber}
            accountnumberstate={accountnumberstate}
            setaccountnumberstate={setaccountnumberstate}
            multiSelect={true}
            setDefaultAccountNumber={setDefaultAccountNumber}
            accountDefaultNumber={accountDefaultNumber}
            flow={"txnViewAll"}
            popType={"ownerStatement"}
          />
        </div>
      )}

      <div
        className={` bg-custom-appBack flex flex-col overflow-hidden ${props?.flow === "rejectStatementdetails" && "relative"} ${props?.popType == "ownerStatement" ? " flex-1" : props?.popType ? "h-full" : "h-full-height"}`}
      >
        <div
          className={`hidden ${props?.popType == "ownerStatement" || props?.popType ? "hidden" : "Qsmd:block"} `}
          style={{
            minHeight:
              props?.popType == "ownerStatement" || props?.popType
                ? "var(--navbar-height)"
                : "var(--navbar-breadcrumb-height)",
            backgroundColor: "var(--primary-nav)",
            zIndex: "var(--z-index-header)",
          }}
        ></div>
        <div
          className={`${
            props?.popType == "ownerStatement" || props?.popType
              ? "itemised-owner-div-container-popup"
              : "itemised-owner-div-container"
          }`}
        >
          <StatementTopNavComponent
            loading={false}
            topNavCtaBtn1Props={
              matchButton
                ? {
                    btnText:
                      selectStatementRow?.length >
                      GlobalConfiguration.lengthCheckZero
                        ? TEXT?.CLEAR
                        : TEXT?.CANCEL,
                    btnType: TEXT?.BUTTON,
                    enabledBgColor: "var(--primary-nav-act)",
                    handleFunction: (e) => {
                      setUnMatchStatement("");
                      setMatchStatement("");
                      if (
                        selectStatementRow?.length >
                        GlobalConfiguration.lengthCheckZero
                      ) {
                        setSelectStatementRow([]);
                      } else {
                        setFlowType("");
                        setMatchButton(false);
                        setMatchRemiId([]);
                        setTotalRemiAccount([]);
                        setSelectedCardIds([]);
                        setSelectStatementRow([]);
                        setSelectStatementType(false);
                        setPageSize(PaginationConfiguration.paginationSmall);
                      }
                    },

                    enabledTextColor: "var(--text-primary)",
                    isDisabled: false,
                    hoverOption: TEXT?.WHITE,
                  }
                : undefined
            }
            downloadFileProps={
              !matchButton
                ? {
                    btnText: TEXT?.DOWNLOAD_STATEMENT,
                    dropdownOptions: ["XLSX", "CSV", "TSV", "PDF"],
                    icon: ICONS?.DOWNLOAD_STATEMENT,
                    isDisabled:
                      props?.popType && props?.flow !== "ownerDetail"
                        ? true
                        : isDisabled ||
                          !(type === TEXT?.REMITTER_DETAILS ||
                          props?.flow === TEXT?.REMITTER_DETAILS ||
                          props?.flow === "rejectStatementdetails"
                            ? getAssociatedItemisedData?.ecollection_callbacks
                                ?.length
                            : ownerAllAccItemisedData?.ecollection_callbacks
                                ?.length),
                    handleFunction: (e) => {
                      if (props?.popType && props?.flow !== "ownerDetail") {
                        actionRestricted();
                      } else {
                        if (
                          ownerAllAccItemisedData === null ||
                          ownerAllAccItemisedData?.total_count ===
                            GlobalConfiguration.lengthCheckZero ||
                          getAssociatedItemisedData?.ecollection_callbacks
                            ?.length === GlobalConfiguration.lengthCheckZero
                        ) {
                          e.stopPropagation();
                          return;
                        } else {
                          downloadStatement();
                        }
                      }
                    },
                    selectedOption: selectedType,
                    setSelectedOption: setSelectedType,
                  }
                : false
            }
            iconRoundProps={{
              enabledBgColor: "var(--primary-bg)",
              isLoading: false,
              handleFunction: (e) => {
                if (props?.flow === "rejectStatementdetails") {
                  actionRestricted();
                } else if (!accountNumber.length) {
                  return;
                } else {
                  move();
                  fetchData();
                }
              },
              isDisabled:
                props?.flow === "rejectStatementdetails" ||
                !accountNumber.length
                  ? true
                  : false,
              icon: ICONS.RELOAD_REFRESH_WHITE,
              title: TEXT?.REFRESH_ALL_BALANCES,
              hoverOption: TEXT?.WHITE,
            }}
            topNavCtaBtn2Props={
              matchButton
                ? {
                    btnText: matchCondition ? TEXT?.MATCH : TEXT?.CONFIRM,
                    btnType: TEXT?.BUTTON,
                    isLoading: matchLoader,
                    isLoaderNeeded: true,
                    enabledBgColor:
                      selectStatementRow?.length >
                        GlobalConfiguration.lengthCheckZero && !matchCondition
                        ? "var(--text-primary)"
                        : matchCondition &&
                            selectStatementRow?.length >
                              GlobalConfiguration.lengthCheckZero
                          ? "var(--positive-act)"
                          : "var(--text-disabled)",
                    handleFunction: (e) => {
                      if (
                        selectStatementRow?.length >
                        GlobalConfiguration.lengthCheckZero
                      ) {
                        if (matchCondition) {
                          handleMatchStatement(matchId);
                        } else {
                          setShowRemiAccounts(true);
                          setRemType("remitterMatch");
                        }
                      }
                    },
                    inActiveVariantNeeded: true,
                    enabledTextColor:
                      selectStatementRow?.length >
                        GlobalConfiguration.lengthCheckZero && !matchCondition
                        ? "var(--primary-bg)"
                        : matchCondition &&
                            selectStatementRow?.length >
                              GlobalConfiguration.lengthCheckZero
                          ? "var(--text-primary)"
                          : "var(--text-primary)",
                    isDisabled:
                      selectStatementRow?.length ===
                      GlobalConfiguration.lengthCheckZero,

                    hoverOption: TEXT?.BLACK,
                  }
                : false
            }
            BottomSubTextVaraint={"primary"}
            BottomHeader={
              matchButton ? (
                <>
                  Select transactions to match to
                  <span
                    className={`${remitterName ? "font-semibold" : "font-normal"} ml-margin-xs`}
                  >
                    {remitterName || TEXT?.REMITTER_ACCOUNTS?.toLowerCase()}
                  </span>
                  . Auto-refresh is unavailable while matching remitters.
                </>
              ) : (
                <>
                  Statement updated as per bank :{" "}
                  {new Date()
                    .toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    })
                    .replace(" ", " ")
                    .replace(/(\w{3}) (\d{4})/, "$1, $2")}
                  {!isToday(endDateState) || accountNumber?.length ? "," : ""}{" "}
                  {!isToday(endDateState)
                    ? "auto-refresh is unavailable for past date ranges."
                    : ""}
                </>
              )
            }
            countDownTimer={isToday(endDateState) && accountNumber?.length}
            countDownTimerDisabled={!accountNumber?.length || matchButton}
            resetCountDownTimer={resetTrigger}
            selectionText={`Transactions selected : ${totalSelectedCount}`}
            selectionBtnProps={{
              btnText: `Select up to ${pageSize}`,
              btnType: TEXT?.BUTTON,
              handleFunction: () => {
                if (matchLoader) {
                  return;
                } else {
                  const callbacks =
                    type === TEXT?.REMITTER_DETAILS ||
                    props?.flow === TEXT?.REMITTER_DETAILS ||
                    props?.flow === "rejectStatementdetails"
                      ? getAssociatedItemisedData?.ecollection_callbacks
                      : ownerAllAccItemisedData?.ecollection_callbacks;

                  const visibleRows =
                    callbacks?.map((item, index) => ({
                      rowId:
                        item?.ecollection_callback_id ||
                        item?.id ||
                        `${currentPage}-${index}`,
                      callback: item,
                    })) || [];

                  if (shouldClearPreviousSelection) {
                    setSelectStatementRow(selectedLiveStatement || []);

                    const additionalIds = Array.isArray(remiAcoountId)
                      ? remiAcoountId
                      : remiAcoountId
                        ? [remiAcoountId]
                        : [];

                    setMatchRemiId(additionalIds);

                    setSelectedCardIds(additionalIds);

                    return;
                  }

                  setSelectStatementRow((prev) => {
                    const selectableRows = visibleRows.filter(
                      ({ rowId }) => !selectedLiveStatement?.includes(rowId),
                    );

                    const selectableRowIds = selectableRows.map(
                      ({ rowId }) => rowId,
                    );

                    const totalUserSelectedCount = prev.filter(
                      (id) => !selectedLiveStatement?.includes(id),
                    ).length;

                    const shouldClearAll =
                      currentPageSelectedCount ===
                        currentPageSelectableIds.length &&
                      currentPageSelectableIds.length >
                        GlobalConfiguration?.lengthCheckZero;

                    if (shouldClearAll) {
                      const additionalIds = Array.isArray(remiAcoountId)
                        ? remiAcoountId
                        : remiAcoountId
                          ? [remiAcoountId]
                          : [];

                      setMatchRemiId(additionalIds);
                      setSelectedCardIds(additionalIds);

                      return [];
                    }

                    const protectedRows = prev.filter((id) =>
                      selectedLiveStatement?.includes(id),
                    );

                    const rowsToSelect = selectableRowIds
                      .filter((id) => !prev.includes(id))
                      .slice(0, remainingSelection);

                    const updatedRows = [
                      ...new Set([
                        ...protectedRows,
                        ...prev.filter(
                          (id) => !selectedLiveStatement?.includes(id),
                        ),
                        ...rowsToSelect,
                      ]),
                    ];

                    return updatedRows;
                  });

                  setSelectedCardIds(
                    Array.isArray(remiAcoountId)
                      ? remiAcoountId
                      : remiAcoountId
                        ? [remiAcoountId]
                        : [],
                  );
                }
              },

              enabledBgColor:
                isAllVisibleSelected &&
                !ownerAllAccItemisedLoading &&
                !getAssociatedItemisedLoading
                  ? "var(--positive-bg)"
                  : "var(--primary-nav-act)",

              hoverOption: isAllVisibleSelected ? TEXT?.BLACK : TEXT?.WHITE,

              enabledTextColor: "var(--text-primary)",

              isDisabled:
                ownerAllAccItemisedLoading ||
                getAssociatedItemisedLoading ||
                matchLoader,

              icon:
                isAllVisibleSelected && !ownerAllAccItemisedLoading
                  ? ICONS.SELECTED_WITH_GREEN_CIRCLE
                  : ICONS.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE,
            }}
            matchRemitterProps={
              !matchButton && props?.flow !== "rejectStatementdetails"
                ? {
                    handleFunction: () => {
                      if (props?.popType) {
                        actionRestricted();
                      } else {
                        if (hasMatchPermission) {
                          if (
                            !accountNumber.length ||
                            ownerAllAccItemisedLoading ||
                            statementType === TEXT?.DEBIT
                          ) {
                            return;
                          } else {
                            setMatchButton(!matchButton);
                          }
                        } else {
                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "AMapping",
                            },
                          });
                        }
                      }
                    },
                    isDisabled:
                      !hasMatchPermission || statementType === TEXT?.DEBIT
                        ? true
                        : props?.popType
                          ? true
                          : !accountNumber.length || ownerAllAccItemisedLoading,
                    enabledBgColor: "var(--primary-bg)",
                    isLoading: false,
                    imgColor: "var(--text-primary)",
                    hoverOption: TEXT?.WHITE,
                    buttonRef: null,
                    title: TEXT?.IDENTIFY_SOURCE_CREDIT,
                  }
                : undefined
            }
            isSelectionView={matchButton ? true : false}
            filteredSearchProps={{
              isFilterDisabled:
                props?.statement_entry_id || !accountNumber.length,
              isColumnDisabled: props?.statement_entry_id
                ? true
                : !accountNumber.length,
              setShowInnerSearchBar: setShowInnerSearchBar,
              showSearchBar: false,
              isSearchDisabled: true,

              onSearchInput: handleSearch,
              searchText: searchUserTextDebounce,
              statementType: statementType,
              searchPlaceholder: TEXT?.SEARCH_CONSOLIDATE_STATEMENT,
              columnOptions: [
                { colName: "Bank", colWidth: "column-width-sm", flex: 0 },
                {
                  colName: "Transaction date",
                  colWidth: "column-width-md",
                  flex: 0,
                },
                {
                  colName: "Value date",
                  colWidth: "column-width-md",
                  flex: 0,
                },
                {
                  colName: "Party name",
                  colWidth: "column-width-lg",
                  flex: 1,
                },
                { colName: "Amount", colWidth: "column-width-md", flex: 0 },
                {
                  colName: "Narration",
                  colWidth: "column-width-lg",
                  flex: 1,
                },
                {
                  colName: "Bank reference",
                  colWidth: "column-width-md",
                  flex: 0,
                },
                {
                  colName: "Party account number",
                  colWidth: "column-width-md",
                  flex: 0,
                },
                {
                  colName: "Party IFSC",
                  colWidth: "column-width-md",
                  flex: 0,
                },
                {
                  colName: "Description",
                  colWidth: "column-width-lg",
                  flex: 1,
                },

                {
                  colName: "Remitter account",
                  colWidth: "column-width-md",
                  flex: 0,
                  isDisabled: statementType === "Debit" ? true : false,
                },
              ],

              filterItems: [
                {
                  name: TEXT?.CREDIT_AMOUNT,
                  short_name: "Cr. Amt. -",
                  isMulti: false,
                  value: creditAmount,
                  setValue: (val) => {
                    setCreditAmount(val);
                  },
                  isDropdown: false,
                  isDisabled:
                    ownerAllAccItemisedLoading ||
                    props?.popType === "ownerStatement" ||
                    props?.flow === "rejectStatementdetails",
                  valueType: "string",
                },
              ],

              columnValue: additionalDetailColState,
              columnHandleChange: (val) => {
                handleAddDetail(val ? val : defaultAdditionalDetailCol);
              },
              isColumnDefaultDisabled:
                JSON.stringify(
                  defaultAdditionalDetailCol?.filter(
                    (itm) =>
                      itm.colName !==
                      (statementType === TEXT?.DEBIT
                        ? TEXT?.REMITTER_ACCOUNT
                        : ""),
                  ),
                ) === JSON.stringify(additionalDetailColState) ||
                JSON.stringify(
                  defaultAdditionalDetailCol?.filter(
                    (itm) =>
                      itm.colName !==
                      (statementType === TEXT?.DEBIT
                        ? TEXT?.REMITTER_ACCOUNT
                        : ""),
                  ),
                ) === JSON.stringify(additionalDetailColState),
              handleColumnDefault: () => {
                if (statementType === TEXT?.DEBIT) {
                  setAdditionalDetailsColState(
                    defaultAdditionalDetailCol.filter(
                      (itm) => itm.colName !== TEXT?.REMITTER_ACCOUNT,
                    ),
                  );
                } else {
                  setAdditionalDetailsColState(defaultAdditionalDetailCol);
                }
              },

              filters: [
                {
                  name: globalTextFormat(TEXT?.OWNER_ACCOUNT, [0]),
                  filterType: "accountSelect",
                  btnProps: {
                    btnText: accountnumberstate.length
                      ? `${accountnumberstate.length} selected`
                      : TEXT?.SELECT_ACCOUNTS,
                    enabledTextColor: "var(--text-primary)",
                    enabledBgColor: "var(--primary-nav-act)",
                    isDisabled:
                      props?.flow === "rejectStatementdetails" ||
                      props?.flow === "ownerDetail",
                    handleFunction: () => {
                      if (
                        props?.popType !== "ownerStatement" &&
                        props?.flow !== "ownerDetail"
                      ) {
                        if (props?.flow !== "rejectStatementdetails") {
                          setShowOwnerPopup(true);
                        }
                      }
                    },
                  },
                },
                {
                  name: TEXT?.AMOUNT_RANGE,
                  filterType: "amountRange",
                  variant: TEXT?.SINGLE,
                  size: TEXT?.SMALL,
                  value: isAmtFilterApplied,
                  rangeValue: amountRangeFilter,
                  setShowAmtFilterDiv: setShowAmtFilterDiv,
                  setIsAmtFilterApplied: setIsAmtFilterApplied,
                  handleChange: (val) => {
                    if (typeof val === "function") {
                      setAmountRangeFilter((prev) => val(prev));
                      return;
                    }

                    if (val && typeof val === "object") {
                      const nextMin = val?.min ?? "";
                      const nextMax = val?.max ?? "";
                      setAmountRangeFilter({
                        min: nextMin,
                        max: nextMax,
                      });
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleSubmit("min_amount", nextMin);
                      handleSubmit("max_amount", nextMax);
                      return;
                    }

                    setAmountRangeFilter({ min: "", max: "" });
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    handleSubmit("min_amount", "");
                    handleSubmit("max_amount", "");
                  },
                },

                {
                  name: TEXT?.DATE_RANGE,
                  filterType: TEXT?.CALENDER,
                  variant: TEXT?.RANGE,
                  size: TEXT?.SMALL,
                  value: startDateState && endDateState,
                  isDisable: false,
                  startDate: startDateState
                    ? new Date(
                        startDateState * IntervalConfiguration.intervalMedium,
                      )
                    : startDateState,

                  endDate: endDateState
                    ? new Date(
                        endDateState * IntervalConfiguration.intervalMedium,
                      )
                    : endDateState,
                  maxDate: calenderMaxDate,
                  handleChange: (date) => {
                    setIsDateConfirm(date ? true : false);
                    handleDateChange(date);
                  },
                },
                {
                  name: TEXT?.MATCH_STATUS,
                  filterType: TEXT?.DROPDOWN,
                  variant: TEXT?.SINGLE,
                  options: ["Matched", "Unmatched"],
                  size: TEXT?.SMALL,
                  value: matchStatement || unmatchStatement,
                  dropdownPlaceHolder: "Select status",
                  isDisabled: props?.flow === "rejectStatementdetails",

                  statusPop: true,
                  handleChange: (value) => {
                    if (value === TEXT?.MATCHED) {
                      setMatchStatement(value);
                      setUnMatchStatement("");
                    } else {
                      setUnMatchStatement(value);
                      setMatchStatement("");
                    }
                    move();
                  },
                },
              ],
              isFilterClearAllDisabled:
                props?.flow === "rejectStatementdetails"
                  ? !amountRangeFilter?.min &&
                    !amountRangeFilter?.max &&
                    !startDateState &&
                    !endDateState
                  : !matchStatement?.length &&
                    !unmatchStatement?.length &&
                    !amountRangeFilter?.min &&
                    !amountRangeFilter?.max &&
                    startDateState === defaultStartDate &&
                    endDateState === defaultEndDate &&
                    !condition,

              isSearchClearAllDisabled: false,
              inputData: [],
              active: active,
              setActive: setActive,
              loading: ownerAllAccItemisedLoading,
              setLoading: setLoadingData,
              isShowFilter: true,
              isShowColumn: true,
              loadingData: loadingData,
            }}
            typeToggleState={statementType}
            typeToggleSetter={(val) => {
              handleAddDetail(TEXT?.REMITTER_ACCOUNT);
              setStatementType(val);
              setCurrentPage(GlobalConfiguration.lengthCheckOne);
            }}
            isTypeToggleDisabled={
              ownerAllAccItemisedLoading || !accountNumber.length || matchButton
            }
            openFilter={openDateFilter}
            setOpenFilter={setopenDateFilter}
            ispagination={
              (type === TEXT?.REMITTER_DETAILS ||
              props?.flow === TEXT?.REMITTER_DETAILS ||
              props?.flow === "rejectStatementdetails"
                ? getAssociatedItemisedData?.ecollection_callbacks?.length
                : ownerAllAccItemisedData?.ecollection_callbacks?.length) >
                GlobalConfiguration.lengthCheckZero && matchButton
                ? true
                : false
            }
          />
        </div>

        <div
          style={{
            position: showInnerSearchBar ? "absolute" : "relative",
            opacity: showInnerSearchBar
              ? "var(--dark-opacity)"
              : "var(--opcacity_none)",
            display: showInnerSearchBar ? "block" : "hidden",
            backgroundColor: showInnerSearchBar ? "var(--PopUp-BackDrop)" : "",
            height: showInnerSearchBar ? "var(--height-full)" : "0",
            width: showInnerSearchBar ? "var(--width-full)" : "0",
            zIndex: "var(--z-index-content)",
          }}
        ></div>

        <div
          ref={scrollRef}
          style={{
            overflowX: (
              type === TEXT?.REMITTER_DETAILS ||
              props?.flow === TEXT?.REMITTER_DETAILS ||
              props?.flow === "rejectStatementdetails"
                ? getAssociatedItemisedLoading ||
                  !getAssociatedItemisedData?.ecollection_callbacks?.length
                : ownerAllAccItemisedLoading ||
                  !ownerAllAccItemisedData?.ecollection_callbacks?.length
            )
              ? "hidden"
              : "scroll",
            marginBottom:
              ownerAllAccItemisedLoading || getAssociatedItemisedLoading
                ? ""
                : ((type === TEXT?.REMITTER_DETAILS ||
                      props?.flow === TEXT?.REMITTER_DETAILS) &&
                    props?.flow !== "rejectStatementdetails"
                      ? getAssociatedItemisedData?.ecollection_callbacks?.length
                      : ownerAllAccItemisedData?.ecollection_callbacks
                          ?.length) > GlobalConfiguration.lengthCheckZero
                  ? "var(--pagination-height)"
                  : "",
            borderRadius: "inherit",
            width:
              props?.popType == "ownerStatement" || props?.popType
                ? "var(--popup-width)"
                : "var(--full-width)",
          }}
          className={`${
            props?.popType == "ownerStatement" || props?.popType
              ? "popupstatementviewallscrolls"
              : ""
          } overflow-y-hidden bg-primary-bg overflow-x-auto flex flex-col  statementviewallscroll   flex-1`}
        >
          <div
            style={{
              display:
                !(type === TEXT?.REMITTER_DETAILS ||
                props?.flow === TEXT?.REMITTER_DETAILS ||
                props?.flow === "rejectStatementdetails"
                  ? getAssociatedItemisedData?.ecollection_callbacks?.length
                  : ownerAllAccItemisedData?.ecollection_callbacks?.length) ||
                ownerAllAccItemisedLoading ||
                getAssociatedItemisedLoading
                  ? "none"
                  : "",
              background: !ownerAllAccItemisedData?.ecollection_callbacks
                ?.length
                ? "var(--primary-bg)"
                : !getAssociatedItemisedData?.ecollection_callbacks?.length
                  ? "var(--primary-bg)"
                  : "var(--primary-nav)",
              zIndex: openMatchPopup
                ? "var(--z-index-base)"
                : "var(--z-index-fixed-ui)",
              width:
                props?.popType == "ownerStatement" || props?.popType
                  ? "var(--popup-width)"
                  : "var(--width-full)",
              bottom:
                props?.flow === "rejectStatementdetails"
                  ? "var(--bottom-base)"
                  : props?.popType == "ownerStatement" || props?.popType
                    ? "var(--bottom-sm)"
                    : "var(--bottom-base)",
              borderRadius:
                props?.popType == "ownerStatement" || props?.popType
                  ? " var(--border-radius-md)"
                  : "none",
              pointerEvents: showInnerSearchBar && "none",
            }}
            className={`fixed w-width-full ${props?.flow === "rejectStatementdetails" || props?.flow !== "ownerDetail" ? "absolute" : "fixed"} ${
              (props?.popType == "ownerStatement" || props?.popType) &&
              props?.flow !== "ownerDetail"
                ? "ownerdetailsresponsivestatement"
                : ""
            }`}
          >
            <div
              className={` ${
                showInnerSearchBar &&
                " absolute opacity-light-opacity w-full h-full z-z-index-header bg-PopUp-BackDrop pointer-events-none "
              }`}
            ></div>
            <PaginationComponent
              handleSelect={handleSelect}
              selectedValue={selectedValue}
              data={ownerAllAccItemisedData || getAssociatedItemisedData || []}
              pageSize={pageSize}
              dropdownOptions={dropdownOptions}
              handlePagination={handlePagination}
              currentPage={currentPage}
              setIsOpen={setIsOpen}
              typePopup={
                props?.flow === "rejectStatementdetails"
                  ? false
                  : props?.popType == "ownerStatement" || props?.popType
                    ? true
                    : false
              }
            />
          </div>

          <div
            className={`w-max min-w-full z-z-index-content  ${showInnerSearchBar && " opacity-light-opacity bg-PopUp-BackDrop"} `}
          >
            <div
              className={`itemised-table-div-container ${showInnerSearchBar && " opacity-light-opacity bg-PopUp-BackDrop"}  `}
            >
              {matchButton && (
                <>
                  {" "}
                  <div>
                    {" "}
                    <p
                      className={`text-font-xs px-padding-xl h-auto break-all py-padding-button-l border-r border-primary-bg text-text-secondary text-center`}
                    >
                      Select
                    </p>
                  </div>
                </>
              )}

              {additionalDetailColState?.map((column, index) => {
                return (
                  <>
                    <p
                      style={{
                        minWidth: `var(--${column.colWidth})`,
                        flex: `${column.flex}`,
                      }}
                      className={`text-font-xs px-padding-md h-auto py-padding-button-l text-text-secondary text-center`}
                    >
                      {column.colName === TEXT?.AMOUNT
                        ? statementType === TEXT?.CREDIT
                          ? TEXT?.CREDIT_AMOUNT
                          : TEXT?.DEBIT_AMOUNT
                        : column.colName}
                    </p>
                    <div
                      style={{
                        display:
                          index ===
                          additionalDetailColState.length -
                            GlobalConfiguration?.lengthCheckOne
                            ? "none"
                            : "block",
                      }}
                      className="itemised-border-mid-div"
                    ></div>
                  </>
                );
              })}
            </div>
          </div>

          {!accountNumber.length ? (
            <div className="h-height-full flex-col m-auto pb-padding-md  overflow-y-scroll justify-center items-center flex w-full">
              <img
                style={{
                  marginBottom: "var(--margin-md)",
                  paddingTop: "var(--padding-xl)",
                }}
                src={ICONS?.VIEW_CATEGORY_GRAPHICS}
                alt="No accounts found"
                className="statement_noacc_found"
              />
              <p className="select-text flex flex-col">
                <span>Select the accounts to view live statement.</span>
              </p>
              <div>
                <PrimaryButton
                  enabledBgColor="var(--primary-act)"
                  btnText="Select accounts"
                  enabledTextColor="var(--text-primary)"
                  handleFunction={() => {
                    setShowOwnerPopup(true);
                  }}
                  buttonRef={selectAccountRef}
                  hoverOption="white"
                />
              </div>
            </div>
          ) : ownerAllAccItemisedLoading || getAssociatedItemisedLoading ? (
            <div
              className={`absolute top-auto flex h-height-lg m-auto justify-center items-center ${
                props?.popType === "ownerStatement"
                  ? "w-full-popup-width"
                  : "w-full-width"
              }`}
            >
              <Loader />
            </div>
          ) : ownerAllAccItemisedData?.total_count >
              GlobalConfiguration.lengthCheckZero ||
            (getAssociatedItemisedData?.ecollection_callbacks?.length &&
              flowType !== "remitter_details_match_statement" &&
              selectStatementType !== "remitter_edit_match_statement") ? (
            <>
              <div
                ref={scrollTopRef}
                style={{
                  flex: "1",

                  overflowY:
                    type === TEXT?.REMITTER_DETAILS ||
                    props?.flow === TEXT?.REMITTER_DETAILS ||
                    props?.flow === "rejectStatementdetails"
                      ? getAssociatedItemisedLoading ||
                        getAssociatedItemisedData?.owner_account_details
                          ?.statement?.length
                        ? "hidden"
                        : "auto"
                      : ownerAllAccItemisedLoading ||
                          ownerAllAccItemisedData?.owner_account_details
                            ?.statement?.length
                        ? "hidden"
                        : "auto",
                }}
                className={`${props?.popType === "ownerStatement" ? "" : "mb-margin-md"} overflow-y-scroll w-max min-w-full mb-margin-lg Qsmd:mb-margin-base pb-padding-xl Qsmd:pb-padding-base  mt-margin-base`}
              >
                {(
                  ownerAllAccItemisedData || getAssociatedItemisedData
                )?.ecollection_callbacks?.map((statement, index) => {
                  const rowId =
                    statement?.ecollection_callback_id ||
                    statement?.id ||
                    `${currentPage}-${index}`;

                  const isPreSelected = selectedLiveStatement.includes(rowId);
                  const isSelected =
                    isPreSelected || selectStatementRow.includes(rowId);
                  return (
                    <div
                      onClick={() => {
                        if (!matchButton) return;

                        if (isPreSelected) {
                          CommonToast({
                            text: "Unmatching transactions are restricted in the matching flow.",
                            icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
                            variant: "var(--error)",
                          });
                          return;
                        }

                        const isSelected = selectStatementRow.includes(rowId);

                        const currentSelectedCount = selectStatementRow.filter(
                          (id) => !selectedLiveStatement?.includes(id),
                        ).length;

                        const maxLimit = Number(pageSize);

                        if (!isSelected && currentSelectedCount >= maxLimit) {
                          CommonToast({
                            text: TEXT?.MAXIMUM_LIMIT_REACHED,
                            icon: ICONS.ERROR_WITH_WHITE_CIRCLE,
                            variant: "var(--error)",
                            buttonNeeded: false,
                          });
                          return;
                        }

                        setSelectStatementRow((prev) =>
                          isSelected
                            ? prev.filter((id) => id !== rowId)
                            : [...prev, rowId],
                        );

                        setSelectedCardIds(
                          Array.isArray(remiAcoountId)
                            ? remiAcoountId
                            : [remiAcoountId],
                        );
                      }}
                      className={`itemised-table-div-content
                         ${isPreSelected && matchButton && "opacity-light-opacity"}
                                 ${
                                   matchLoader && !isPreSelected
                                     ? "cursor-default opacity-50"
                                     : matchButton && !isPreSelected
                                       ? "cursor-pointer"
                                       : "cursor-default"
                                 }
                                ${
                                  isSelected && matchButton
                                    ? `bg-positive-bg ${!showInnerSearchBar && "z-z-index-content"}`
                                    : isSelected
                                      ? "global-hover-black"
                                      : matchButton
                                        ? `global-hover-white ${!showInnerSearchBar && "z-z-index-content"}`
                                        : ""
                                }
                                        `}
                    >
                      {matchButton && (
                        <>
                          {" "}
                          <div className="px-padding-xl flex items-center justify-center">
                            <img
                              src={
                                isSelected
                                  ? ICONS.SELECTED_WITH_GREEN_CIRCLE
                                  : ICONS.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE
                              }
                              alt="selection"
                              className="h-icon-sm ml-margin-sm"
                            />
                          </div>
                        </>
                      )}
                      {additionalDetailColState?.some(
                        (x) => x.colName === TEXT?.BANK,
                      ) && (
                        <>
                          <div className="text-font-xs flex-0 pr-padding-md pl-padding-lg h-auto py-padding-xs  text-text-secondary text-center min-w-column-width-sm w-column-width-sm flex items-center">
                            <div className="py-padding-button-s px-padding-sm rounded-border-radius-md bg-text-primary flex justify-center items-center">
                              <div className="w-banklogo-width-sm h-banklogo-height-sm flex-shrink-0">
                                <IfscCodeMapper
                                  ifscCode={statement?.party_ifsc}
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                      {additionalDetailColState.some(
                        (x) => x.colName === TEXT?.TRANSACTION_DATE,
                      ) && (
                        <>
                          <p
                            className={
                              "text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-0 text-text-secondary text-center w-column-width-md min-w-column-width-md"
                            }
                          >
                            {statement?.transaction_date
                              ? formatDateandTime(statement?.transaction_date)
                              : "-"}
                          </p>
                        </>
                      )}
                      {additionalDetailColState.some(
                        (x) => x.colName === TEXT?.VALUE_DATE,
                      ) && (
                        <>
                          <p
                            className={
                              "text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-0 text-text-secondary text-center w-column-width-md min-w-column-width-md"
                            }
                          >
                            {statement?.value_date
                              ? formatDateandTime(statement?.value_date)
                              : "-"}
                          </p>
                        </>
                      )}
                      {additionalDetailColState.some(
                        (x) => x.colName === TEXT?.PARTY_NAME,
                      ) && (
                        <>
                          <p className="text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-1 text-text-secondary text-center w-column-width-lg min-w-column-width-lg">
                            {statement?.party_name || "-"}
                          </p>
                        </>
                      )}
                      {additionalDetailColState.some(
                        (x) => x.colName === TEXT?.AMOUNT,
                      ) && (
                        <>
                          <div
                            className={
                              " text-font-xs px-padding-md h-auto break-all flex items-center justify-end py-padding-xs flex-0 text-text-secondary text-right w-column-width-md min-w-column-width-md"
                            }
                            style={{
                              color:
                                statementType === TEXT?.CREDIT
                                  ? "var(--settled)"
                                  : "var(--failed)",
                            }}
                          >
                            INR{" "}
                            <FormatAmount price={Number(statement?.amount)} />
                          </div>
                        </>
                      )}
                      {additionalDetailColState.some(
                        (x) => x.colName === TEXT?.NARRATION,
                      ) && (
                        <>
                          <p
                            className={
                              "text-wrap  text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-1 text-text-secondary text-center w-column-width-lg min-w-column-width-lg"
                            }
                          >
                            {statement?.narration || "-"}
                          </p>
                        </>
                      )}
                      {additionalDetailColState.some(
                        (x) => x.colName === TEXT?.BANK_REFERENCE,
                      ) && (
                        <>
                          <p
                            className={
                              "break-all text-wrap text-font-xs px-padding-md h-auto flex items-center justify-center py-padding-xs flex-0 text-text-secondary text-center w-column-width-md min-w-column-width-md"
                            }
                          >
                            {statement?.bank_reference || "-"}
                          </p>
                        </>
                      )}
                      {additionalDetailColState.some(
                        (x) => x.colName === TEXT?.PARTY_ACCOUNT_NUMBER,
                      ) && (
                        <>
                          <p
                            className={
                              "text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-0 text-text-secondary text-center w-column-width-md min-w-column-width-md"
                            }
                          >
                            {statement?.party_account_number
                              ? formatAccountNumber(
                                  statement?.party_account_number,
                                )
                              : "-"}
                          </p>
                        </>
                      )}
                      {additionalDetailColState.some(
                        (x) => x.colName === TEXT?.PARTY_IFSC,
                      ) && (
                        <>
                          <p className="text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-0 text-text-secondary text-center w-column-width-md min-w-column-width-md">
                            {statement?.party_ifsc || "-"}
                          </p>
                        </>
                      )}
                      {additionalDetailColState.some(
                        (x) => x.colName === TEXT?.DESCRIPTION,
                      ) && (
                        <div
                          className={
                            " px-padding-md h-auto flex items-center justify-center py-padding-xs flex-1 text-text-primary text-center w-column-width-lg min-w-column-width-lg"
                          }
                        >
                          {statement?.description?.length ? (
                            <div className="flex gap-x-gap-sm justify-center">
                              <p className="text-font-xs text-text-secondary break-all">
                                {linkIdentifier(statement?.description)}
                              </p>
                              <div className="border-r-border h-auto border-primary-act"></div>
                              <img
                                title={TEXT?.EDIT}
                                src={ICONS?.EDIT}
                                alt={TEXT?.EDIT?.toLowerCase()}
                                className={`h-icon-sm w-icon-sm flex-shrink-0 ${(props?.flow === "rejectStatementdetails" || matchButton) && "cursor-not-allowed opacity-light-opacity"} my-auto ${
                                  !services?.includes("ADescription") &&
                                  !services?.includes("Admin")
                                    ? "cursor-not-allowed opacity-light-opacity"
                                    : props?.flow === "rejectStatementdetails"
                                      ? "cursor-not-allowed"
                                      : "cursor-pointer"
                                } `}
                                onClick={() => {
                                  if (
                                    props?.flow === "rejectStatementdetails"
                                  ) {
                                    actionRestricted();
                                  } else if (
                                    !services?.includes("ADescription") &&
                                    !services?.includes("Admin")
                                  ) {
                                    navigate("/feature_not_assigned", {
                                      state: {
                                        unavailableService:
                                          "ADescription,Admin",
                                      },
                                    });
                                  } else {
                                    if (!matchButton) {
                                      setIsEditDescription(true);
                                      setDescription(statement?.description);
                                      setCurrentDescription({
                                        acc_id: statement?.owner_account_id,

                                        description: statement?.description,
                                        ecollection_callback_id:
                                          statement?.ecollection_callback_id,
                                      });
                                      setShowDescriptionPopup(true);
                                    }
                                  }
                                }}
                              />
                            </div>
                          ) : (
                            <PrimaryWithIconButton
                              btnText={TEXT?.ADD_DESCRIPTION}
                              outLineColor={"var(--text-primary)"}
                              btnType={TEXT?.BUTTON}
                              enabledBgColor="transparent"
                              enabledTextColor="var(--text-primary)"
                              hoverOption={TEXT?.WHITE}
                              iconToBeAlign="left"
                              icon={ICONS?.ADD_BUTTON_WHITE}
                              imgColor="var(--text-primary)"
                              isDisabled={
                                props?.flow === "rejectStatementdetails"
                                  ? true
                                  : matchButton
                                    ? true
                                    : !services?.includes("ADescription") &&
                                      !services?.includes("Admin")
                              }
                              handleFunction={() => {
                                if (props?.flow === "rejectStatementdetails") {
                                  actionRestricted();
                                } else {
                                  if (!matchButton) {
                                    if (
                                      !services?.includes("ADescription") &&
                                      !services?.includes("Admin")
                                    ) {
                                      navigate("/feature_not_assigned", {
                                        state: {
                                          unavailableService:
                                            "VAccountBalance,Admin",
                                        },
                                      });
                                    } else {
                                      setIsEditDescription(false);
                                      setShowDescriptionPopup(true);
                                      setCurrentDescription({
                                        acc_id: statement?.owner_account_id,

                                        description: statement?.description,
                                        ecollection_callback_id:
                                          statement?.ecollection_callback_id,
                                      });
                                    }
                                  }
                                }
                              }}
                            />
                          )}
                        </div>
                      )}

                      {props?.flow !== "rejectStatementdetails" &&
                        additionalDetailColState.some(
                          (x) => x.colName === TEXT?.REMITTER_ACCOUNT,
                        ) && (
                          <div
                            className={
                              "  h-auto flex items-center justify-center py-padding-xs flex-1 text-text-primary text-center w-column-width-lg min-w-column-width-lg"
                            }
                          >
                            {statement?.remitter_accounts?.length ? (
                              <div className="flex gap-x-gap-xs w-full px-padding-md">
                                <div className="w-full justify-between items-center flex">
                                  <div
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      if (hasViewPermission) {
                                        if (
                                          props?.flow ===
                                            "rejectStatementdetails" ||
                                          props?.flow === "ownerDetail"
                                        ) {
                                          actionRestricted();
                                        } else {
                                          setShowRemiAccounts(true);
                                          setTotalRemiAccount([
                                            statement?.remitter_accounts?.map(
                                              (itm) => itm.remitter_account_id,
                                            ),
                                          ]);
                                        }
                                      } else {
                                        navigate("/feature_not_assigned", {
                                          state: {
                                            unavailableService: "REVAccount",
                                          },
                                        });
                                      }
                                    }}
                                    className={` text-font-sm text-pending underline ${props?.flow === "rejectStatementdetails" || props?.flow === "ownerDetail" ? "opacity-light-opacity cursor-not-allowed " : !hasViewPermission ? "opacity-light-opacity cursor-not-allowed" : "cursor-pointer"} `}
                                  >
                                    {`${statement?.remitter_accounts?.length}
                                                          matched`}
                                  </div>

                                  <div
                                    className={` rounded-border-radius-md ${matchButton ? "hidden" : "block"} cursor-pointer  `}
                                  >
                                    <SecondaryAnimatedButton
                                      handleFunction={(e) => {
                                        e.stopPropagation();
                                        if (
                                          props?.flow ===
                                            "rejectStatementdetails" ||
                                          props?.flow === "ownerDetail"
                                        ) {
                                          actionRestricted();
                                        } else {
                                          if (!matchButton) {
                                            if (hasUnMatchPermission) {
                                              setShowRemiAccounts(true);
                                              setRemType("remitterUnmatch");
                                              setSelectStatementRow([
                                                statement?.ecollection_callback_id,
                                              ]);
                                              setUnmatchRemiId(
                                                statement?.remitter_accounts?.map(
                                                  (itm) =>
                                                    itm.remitter_account_id,
                                                ),
                                              );
                                            } else {
                                              navigate(
                                                "/feature_not_assigned",
                                                {
                                                  state: {
                                                    unavailableService:
                                                      "RMapping",
                                                  },
                                                },
                                              );
                                            }
                                          }
                                        }
                                      }}
                                      isDisabled={
                                        props?.flow ===
                                          "rejectStatementdetails" ||
                                        props?.flow === "ownerDetail" ||
                                        !hasUnMatchPermission
                                      }
                                      enabledBgColor={"var(--primary-nav)"}
                                      disabledBgColor=""
                                      isLoading={false}
                                      icon={ICONS.UNMATCH}
                                      hoverOption={TEXT?.WHITE}
                                      buttonRef={null}
                                      title={
                                        TEXT?.UNMATCH_REMITTER_ACCOUNTS_TRANSACTION
                                      }
                                      text={TEXT?.UNMATCH}
                                      imgColor={"var(--text-primary)"}
                                    />
                                  </div>
                                </div>

                                <div
                                  className={` ${matchButton ? " hidden" : "flex"}`}
                                >
                                  <div
                                    className={` rounded-border-radius-md  cursor-pointer ${matchButton ? "hidden" : "block"} flex  `}
                                  >
                                    <SecondaryAnimatedButton
                                      handleFunction={(e) => {
                                        e.stopPropagation();

                                        if (
                                          props?.flow ===
                                            "rejectStatementdetails" ||
                                          props?.flow === "ownerDetail"
                                        ) {
                                          actionRestricted();
                                        } else {
                                          if (!matchButton) {
                                            if (hasMatchPermission) {
                                              setShowRemiAccounts(true);
                                              setRemType("remitterMatch");
                                              setSelectStatementRow([
                                                statement?.ecollection_callback_id,
                                              ]);

                                              setMatchRemiId([
                                                ...(statement?.remitter_accounts?.map(
                                                  (itm) =>
                                                    itm.remitter_account_id,
                                                ) || []),
                                                ...(Array.isArray(remiAcoountId)
                                                  ? remiAcoountId
                                                  : remiAcoountId
                                                    ? [remiAcoountId]
                                                    : []),
                                              ]);

                                              setSelectedCardIds(
                                                Array.isArray(remiAcoountId)
                                                  ? remiAcoountId
                                                  : [remiAcoountId],
                                              );
                                            } else {
                                              navigate(
                                                "/feature_not_assigned",
                                                {
                                                  state: {
                                                    unavailableService:
                                                      "AMapping",
                                                  },
                                                },
                                              );
                                            }
                                          }
                                        }
                                      }}
                                      isDisabled={
                                        props?.flow ===
                                          "rejectStatementdetails" ||
                                        props?.flow === "ownerDetail" ||
                                        !hasMatchPermission
                                      }
                                      enabledBgColor={"var(--primary-nav)"}
                                      disabledBgColor=""
                                      isLoading={false}
                                      icon={ICONS.MATCH}
                                      hoverOption={TEXT?.WHITE}
                                      buttonRef={null}
                                      title={
                                        TEXT?.MATCH_REMITTER_ACCOUNT_TO_TRANSACTION
                                      }
                                      text={TEXT?.MATCH}
                                      imgColor={"var(--text-primary)"}
                                    />
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <>
                                <PrimaryWithIconButton
                                  btnText={TEXT?.MATCH_REMITTER_ACCOUNT}
                                  outLineColor={"var(--text-primary)"}
                                  btnType={TEXT?.BUTTON}
                                  enabledBgColor="transparent"
                                  enabledTextColor="var(--text-primary)"
                                  hoverOption={TEXT?.WHITE}
                                  iconToBeAlign="left"
                                  icon={ICONS.MATCHED_WITH_CIRCLE}
                                  imgColor="var(--text-primary)"
                                  isDisabled={
                                    !hasMatchPermission
                                      ? true
                                      : props?.flow ===
                                            "rejectStatementdetails" ||
                                          props?.flow === "ownerDetail"
                                        ? true
                                        : matchButton
                                          ? true
                                          : false
                                  }
                                  handleFunction={(e) => {
                                    e.stopPropagation();
                                    if (
                                      props?.flow ===
                                        "rejectStatementdetails" ||
                                      props?.flow === "ownerDetail"
                                    ) {
                                      actionRestricted();
                                    } else {
                                      if (hasMatchPermission) {
                                        if (!matchButton) {
                                          setSelectStatementRow([
                                            statement?.ecollection_callback_id,
                                          ]);
                                          setOpenMatchPopup(true);
                                        }
                                      } else {
                                        navigate("/feature_not_assigned", {
                                          state: {
                                            unavailableService: "AMapping",
                                          },
                                        });
                                      }
                                    }
                                  }}
                                />
                              </>
                            )}
                          </div>
                        )}
                    </div>
                  );
                })}
              </div>
            </>
          ) : (
            <div
              className={`h-height-full flex-col m-auto  ${
                props?.popType === "ownerStatement"
                  ? "w-full-popup-width"
                  : "w-full-width"
              }  overflow-y-scroll justify-center items-center flex`}
            >
              <img
                src={ICONS?.NO_DATA_FOUND}
                alt={TEXT?.NO_ACCOUNTS_FOUND_NOTE}
                className="w-graphic-rectangle-height-md h-graphic-rectangle-height-md"
              />
              <p className="text-text-primary text-font-sm pt-padding-sm items-center">
                No data found.
              </p>

              <div
                className={condition ? "" : "mt-margin-sm"}
                style={
                  condition ? { paddingTop: "var(--padding-sm)" } : undefined
                }
              >
                <PrimaryButton
                  isDisabled={false}
                  enabledBgColor="var(--primary-act)"
                  btnText={
                    condition ? TEXT?.CLEAR_PARAMETERS : TEXT?.CHANGE_DATE_RANGE
                  }
                  enabledTextColor="var(--text-primary)"
                  handleFunction={
                    condition
                      ? handleClearParameters
                      : () => setopenDateFilter(true)
                  }
                  buttonRef={selectAccountRef}
                  hoverOption={TEXT?.WHITE}
                />
              </div>
            </div>
          )}
        </div>
        <div
          className={`${
            getAssociatedItemisedData?.total_count ===
              GlobalConfiguration.lengthCheckZero ||
            props?.flow !== "rejectStatementdetails" ||
            getAssociatedItemisedLoading ||
            ownerAllAccItemisedLoading
              ? "hidden"
              : "block h-pagination-height"
          }`}
        ></div>
      </div>
    </>
  );
};

export default OwnerAccountConsolidatedLiveStatementComp;
